import React from 'react';
import Tabs from 'antd/lib/tabs';
import { EditProfile, ChangePassword } from './components';

import './SettingsPage.less';

export const SettingsPage = (props) => {
  const { theme } = props;
  const { TabPane } = Tabs;
  window.document.title = `Settings`;

  return (
    <div id="settings-page">
      <div className="settings-page-header">
        <div className="settings-page-title">Settings</div>
        <Tabs className={`app-tabs-${theme}`} defaultActiveKey="1">
          <TabPane tab="Edit Profile" key="1">
            <EditProfile theme={theme} />
          </TabPane>
          <TabPane tab="Change Password" key="2">
            <ChangePassword theme={theme} />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
